import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import { useParams } from 'react-router-dom'
import { getNewsById } from '../api'
import { BottomNavBar } from '../components/Header';
import { getStaticBaseUrl } from '../stores/configStore';

function NewsFull() {
  const { id } = useParams()
  const [news, setNews] = useState(null)
  useEffect(() => {
    getNewsById({ id }).then(setNews)
  }, [id])
  const date = news?.date ? new Date(news.date) : null
  return (
    <div className='NewsFull'>
        <Header />
        <div className="NewsFull__container" style={{ paddingBottom: 80 }}>
            <div className="left">
                <div className="image">
                    {news?.image ? (
                      <img src={`${getStaticBaseUrl()}${news.image}`} alt="news" />
                    ) : (
                    <img src="https://cdn-imgix-open.headout.com/fallback/landscape.svg?w=1188&h=742.5&fm=svg&auto=compress%2Cformat&fit=min" alt="" />
                    )}
                </div>
            </div>
            <div className="right">
                <div className="title">
                    {news?.title}
                </div>
                <div className="text">
                    {news?.text}
                </div>
                <div className="date">
                    {date ? date.toLocaleString('ru-RU', { day: '2-digit', month: 'long', hour: '2-digit', minute: '2-digit' }) : ''}
                </div>
            </div>
        </div>
        <BottomNavBar />
    </div>
  )
}

export default NewsFull